import React, { Fragment, useState, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { useUnreadMessagesContext } from '../contexts/UnreadMessagesContext';
import PropTypes from 'prop-types';
import TicketTab from './TicketTab';
import Section from '../../../components/layout/Section';
import './TicketBasicInformation.scss'
import Workflow from './workflow/Workflow'
import VIRWorkflow from './workflow/VIRWorkflow'
import RTEWorkflow from './workflow/RTEWorkflow';
import RTEDRWorkflow from './workflow/RTEDRWorkflow';
import Messages from './messages/Messages';
import ManageTicket from './manage/ManageTicket';
import Notes from './notes/Notes';
import { useSelector } from 'react-redux';
import { Permissions } from '../../../app/services/Permissions';
import { TicketState } from '../services/TicketState'
import { TicketType } from '../services/TicketType';

const TicketTabbedContainer = (props) => {
    const { ticket } = props;
    const { unreadMessagesCount } = useUnreadMessagesContext();
    const [tab, setTab] = useState('status');
    const closedStates = [TicketState.CLOSED_COMPLETED_IN_OFFICE, TicketState.CLOSED_INCOMPLETE]

    const location = useLocation()
    const history = useHistory()
    const hasManageTabAccess = useSelector(state => (state.accountData.permissions || []).includes(Permissions.VIEW_MANAGE_TAB))
    const hasEditTicketAccess = useSelector(state => (state.accountData.permissions || []).includes(Permissions.EDIT_TICKET))
    const isTicketClosed = ticket && ticket.ticketState && closedStates.includes(ticket.ticketState.identifier)

    const selectTab = (tabKey) => {
        history.replace(`${location.pathname}#${tabKey}`)
    }

    useEffect(() => {
        return () => {
            // This runs when leaving the TicketPage (navigating to another route)
            localStorage.removeItem(`unsentMessage_${ticket?.id}`);
        };
    }, [ticket?.id]);


    useEffect(() => {
        if (location.hash.startsWith('#messages')) {
            setTab('messages')
        } else if (window.location.hash.startsWith('#status')) {
            setTab('status')
        } else if (window.location.hash.startsWith('#manage')) {
            setTab('manage')
        } else if (window.location.hash.startsWith('#notes')) {
            setTab('notes')
        }
    }, [location.hash])

    return (
        <Fragment>
            <div id='ticket-tabs' className='tabs-outer'>
                <div className='columns tickets'>
                    <div className='column is-11 is-offset-1'>
                        <div className='tab-holder'>
                            <TicketTab labelKey='Tickets.Tabs.Status' selectedTab={tab} tabKey='status' onClick={() => selectTab('status')} />
                            <TicketTab labelKey='Tickets.Tabs.ClientMessages' selectedTab={tab}
                                tabKey='messages' onClick={() => selectTab('messages')}
                                showIndicator={unreadMessagesCount > 0}
                            />
                            {hasManageTabAccess &&
                                <TicketTab labelKey='Tickets.Tabs.Manage' selectedTab={tab} tabKey='manage' onClick={() => selectTab('manage')} />
                            }
                            <TicketTab labelKey='Tickets.Tabs.Notes' selectedTab={tab} tabKey='notes' onClick={() => selectTab('notes')} />
                        </div>
                    </div>
                </div>
            </div>
            <Section sectionId={`ticket-tab-${tab}`} className='light-functional-grey'>
                {tab === 'status' && !ticket &&
                    <Workflow />
                }                
                {tab === 'status' && ticket && ticket.ticketType && ticket.ticketType.identifier === TicketType.VDO &&
                    <Workflow />
                }
                {tab === 'status' && ticket && ticket.ticketType && ticket.ticketType.identifier === TicketType.VIR &&
                    <VIRWorkflow />
                }
                {tab === 'status' && ticket && ticket.ticketType && ticket.ticketType.identifier === TicketType.RTE &&
                    <RTEWorkflow />
                }
                {tab === 'status' && ticket && ticket.ticketType && ticket.ticketType.identifier === TicketType.RTEDR &&
                    <RTEDRWorkflow />
                }
                {ticket && tab ==='messages' &&
                    <Messages />
                }
                {ticket && tab === 'manage' && hasManageTabAccess &&
                    <ManageTicket isClosed={isTicketClosed} officeId={ticket.officeId} associateId={ticket.associateId}/>
                }
                {ticket && tab === 'notes' && hasEditTicketAccess &&
                    <Notes isClosed={isTicketClosed} ticketId={ticket.id} />
                }
            </Section>

        </Fragment>
    );
}

TicketTabbedContainer.whyDidYouRender = false;

TicketTabbedContainer.propTypes = {
    ticket: PropTypes.object,
    hasUnreadMessages: PropTypes.bool
}

export default TicketTabbedContainer
